// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2XRwf","title":"FrontImage_title__3C7-D"};